import _ from 'underscore'
import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {arrayToSet, filterMapByKey, filterMapByKeys} from "../../atUtils"
import * as EntitiesActionTypes from "../../entities/actionTypes"
import * as TaskEntitiesActionTypes from "../../entities/tasks/actionTypes"

const createReducer = ({
    TASK_MANAGEMENT = {}
}) => {
    const pageSettings = TASK_MANAGEMENT.PAGE_SETTINGS || {}
    const collapsedProjectsState = TASK_MANAGEMENT.KANBAN_COLLAPSED_PROJECTS_STATE || {}

    const initialState = {
        workflowStatusIds: [],
        taskCountsByWorkflowStatus: {},
        projectIds: [],
        loadingInitialData: false,
        loadingProjectId: null,
        projectLoadingPositions: {},
        projectIdsContainingTasks: {},
        taskIdsOrder: [],
        updatingTaskIds: {},
        isLoaded: false,
        minimizedCards: pageSettings.kanbanCardsMinimized || false,
        loadedTasksNameFilter: '',
        collapsedProjects: {
            all: false,
            ids: [],
            ...collapsedProjectsState,
        },
        needToLoadCounters: false,
    }

    return handleActions({
        [ActionTypes.INITIAL_DATA_SET]: (state, {payload: {workflowStatusIds, taskCountsByWorkflowStatus, projectIds}}) => ({
            ...state,
            projectLoadingPositions: {},
            workflowStatusIds,
            taskCountsByWorkflowStatus,
            projectIds,
            needToLoadCounters: false,
        }),
        [ActionTypes.COLLAPSED_PROJECTS_CHANGE]: (state, {payload: collapsedProjects}) => ({
            ...state,
            collapsedProjects,
        }),
        [ActionTypes.PROJECTS_IDS_CONTAINING_TASK_ADD]: (state, {payload: projectIdsContainingTasks}) => ({
            ...state,
            projectIdsContainingTasks: arrayToSet(projectIdsContainingTasks)
        }),
        [ActionTypes.LOADING_INITIAL_DATA_SET]: (state, {payload: loadingInitialData}) => ({...state, loadingInitialData}),
        [ActionTypes.LOADING_PROJECT_ID_SET]: (state, {payload: loadingProjectId}) => ({...state, loadingProjectId}),
        [ActionTypes.IS_LOADED_SET]: (state, {payload: isLoaded}) => ({...state, isLoaded}),
        [ActionTypes.PROJECT_LOADING_POSITION_SET]: (state, {payload: {id, count, fullyLoaded}}) => {
            return {
                ...state,
                projectLoadingPositions: {
                    ...state.projectLoadingPositions,
                    [id]: {
                        count,
                        fullyLoaded
                    }
                }
            }
        },
        [ActionTypes.PROJECT_LOADING_POSITIONS_RESET]: (state, {payload: projectIds}) => ({
            ...state,
            projectLoadingPositions: filterMapByKeys(state.projectLoadingPositions, projectIds)
        }),
        [ActionTypes.MINIMIZED_CARDS_SET]: (state, {payload: minimizedCards}) => ({
            ...state,
            minimizedCards
        }),
        [ActionTypes.TASKS_COUNT_BY_WORKFLOW_STATUS_SET]: (state, {payload: taskCountsByWorkflowStatus}) => {
            return {
                ...state,
                taskCountsByWorkflowStatus: taskCountsByWorkflowStatus
            }
        },
        [ActionTypes.TASKS_ORDER_ADD]: (state, {payload: taskIdsOrder}) => ({
            ...state,
            taskIdsOrder: _.union(state.taskIdsOrder, taskIdsOrder)
        }),
        [ActionTypes.TASKS_ORDER_PREPEND]: (state, {payload: taskIdsOrder}) => ({
            ...state,
            taskIdsOrder: _.union(taskIdsOrder, state.taskIdsOrder),
        }),
        [ActionTypes.TASKS_ORDER_SET]: (state, {payload: taskIdsOrder}) => ({
            ...state,
            taskIdsOrder: taskIdsOrder
        }),
        [EntitiesActionTypes.TASKS_REMOVE]: (state, {payload: taskIds}) => {
            const taskIdsSet = arrayToSet(taskIds)
            return {
                ...state,
                taskIdsOrder: state.taskIdsOrder.filter(id => !taskIdsSet[id]),
                needToLoadCounters: true,
            }
        },
        [ActionTypes.UPDATING_TASK_ADD]: (state, {payload: taskId}) => ({
            ...state,
            updatingTaskIds: {...state.updatingTaskIds, [taskId]: true}
        }),
        [ActionTypes.UPDATING_TASK_REMOVE]: (state, {payload: taskId}) => ({
            ...state,
            updatingTaskIds: filterMapByKey(state.updatingTaskIds, taskId)
        }),
        [ActionTypes.LOADED_TASKS_NAME_FILTER_SET]: (state, {payload: loadedTasksNameFilter}) => ({
            ...state,
            loadedTasksNameFilter
        }),
        [ActionTypes.NEED_TO_LOAD_COUNTERS_SET]: (state, {payload: needToLoadCounters}) => ({
            ...state,
            needToLoadCounters,
        }),
        [EntitiesActionTypes.PROJECTS_REMOVE]: (state, {payload: projectIds}) => {
            const projectIdsSet = arrayToSet(projectIds)
            return {
                ...state,
                projectIds: state.projectIds.filter(id => !projectIdsSet[id])
            }
        },
        [TaskEntitiesActionTypes.WORKFLOW_STATUS_CHANGED]: (state, {payload: {taskId, workflowStatusId, prevWorkflowStatusId}}) => {
            const tasksCountByWorkflowStatuses = state.taskCountsByWorkflowStatus
            const counters = {
                ...tasksCountByWorkflowStatuses
            }

            if (counters[prevWorkflowStatusId] !== undefined)
                counters[prevWorkflowStatusId] = tasksCountByWorkflowStatuses[prevWorkflowStatusId] - 1

            if (counters[workflowStatusId] !== undefined)
                counters[workflowStatusId] = tasksCountByWorkflowStatuses[workflowStatusId] + 1

            return {
                ...state,
                taskCountsByWorkflowStatus: counters,
            }
        },
    }, initialState)
}

export default createReducer



// WEBPACK FOOTER //
// ./web/js/taskManagement/kanban/reducer.js